import React from 'react';
import { useDocumentMeta } from '../hooks/useDocumentMeta';
import { PageHero } from '../components/PageHero';
import { Calendar, Phone, Facebook } from 'lucide-react';
export function Events() {
  useDocumentMeta('Events & Demo Shoots | Kjergaard Sports', 'Stay updated on events, store updates, and the Buffalo Ridge Demo Shoot hosted by Kjergaard Sports in Lake Benton, Minnesota.');
  return <div data-id="element-229">
      <PageHero title="Events & Demo Shoots" image="https://drwzpk38qkpfb.cloudfront.net/www.ksportsllc.com/uploaded/images/events.jpg?opt=w3" alt="Kjergaard Sports event and in-store display" data-id="element-230" />

      <section className="py-20 bg-brand-offwhite" data-id="element-231">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-232">
          <div className="grid md:grid-cols-2 gap-8 mb-16" data-id="element-233">
            <div className="bg-brand-bone p-10 rounded-sm border border-brand-cream" data-id="element-234">
              <h3 className="text-2xl font-serif text-brand-charcoal mb-4" data-id="element-235">
                Buffalo Ridge Demo Shoot
              </h3>
              <p className="text-brand-charcoal/80 leading-relaxed mb-6" data-id="element-236">
                Our annual Buffalo Ridge Demo Shoot is a unique opportunity to
                test and experience a variety of firearms in a safe, supervised
                environment. It's a great way to try before you buy and connect
                with other shooting sports enthusiasts.
              </p>
            </div>

            <div className="bg-brand-bone p-10 rounded-sm border border-brand-cream" data-id="element-237">
              <h3 className="text-2xl font-serif text-brand-charcoal mb-4" data-id="element-238">
                Store Events & Updates
              </h3>
              <p className="text-brand-charcoal/80 leading-relaxed mb-6" data-id="element-239">
                Throughout the year, we host various store events, manufacturer
                days, class updates, and product demos where applicable.
              </p>
            </div>
          </div>

          <div className="bg-brand-hunter text-brand-offwhite p-10 rounded-sm text-center max-w-4xl mx-auto" data-id="element-240">
            <Calendar className="w-12 h-12 text-brand-leather mx-auto mb-6" data-id="element-241" />
            <h2 className="text-2xl font-serif mb-4" data-id="element-242">Current Event Schedule</h2>
            <p className="text-lg text-brand-offwhite/80 mb-8" data-id="element-243">
              Event dates and details change. Call the store or follow Kjergaard
              Sports on Facebook for current updates.
            </p>
            <div className="flex flex-col sm:flex-row justify-center gap-4" data-id="element-244">
              <a href="tel:507-368-4696" className="bg-brand-leather hover:bg-brand-wood text-brand-offwhite px-8 py-3 rounded-sm font-medium transition-colors flex items-center justify-center" data-id="element-245">
                <Phone className="w-5 h-5 mr-2" data-id="element-246" />
                Call the Store
              </a>
              <a href="https://www.facebook.com/profile.php?id=100057537217940" target="_blank" rel="noopener noreferrer" className="border border-brand-offwhite/30 hover:border-brand-offwhite text-brand-offwhite px-8 py-3 rounded-sm font-medium transition-colors flex items-center justify-center" data-id="element-247">
                <Facebook className="w-5 h-5 mr-2" data-id="element-248" />
                Follow on Facebook
              </a>
            </div>
          </div>
        </div>
      </section>
    </div>;
}